import { ServiceBase } from './ServiceBase'

export class Report extends ServiceBase {}
